import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onFetchShoppingCart, onSetFolio, onSetProductsCount, onSetSelectedSaleChannel, onSetSelectedShoppingcart, onSetSelectedTypeDocument, onSetSelectedWayToPay, selectShoppingcartState, setAction } from "../redux/slices/shoppingCartSlice"
import { ShoppingCartAPI } from "../apis/ShoppingCartAPI"
import { Shoppingcart } from "../types/slices/shoppingCartType"
import { DocumentOfSale } from "../types/slices/documentOfSalesType"
import { TypeSale } from "../types/slices/typeSaleType"
import { WayToPay } from "../types/slices/wayToPayType"
import { SaleChannel } from "../types/slices/saleChannelType"

export const useShoppingCartStore = () => {

    const dispatch = useDispatch()
    const { shoppingcart, shoppingcartSelected, productsCount, status, action,
        selectedTypeDocument, selectedSaleChannel, selectedWayToPay, folio } = useSelector(selectShoppingcartState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idusersession = userData?.id;

    const getShoppingCart = async (data) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ShoppingCartAPI.getShoppingCart(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(onFetchShoppingCart(detail || []))
            dispatch(onSetProductsCount(detail[0]?.quantity_product || 0))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getCountShoppingCart = async (iuser: number, data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ShoppingCartAPI.getCountShoppingCart(iuser, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            dispatch(onSetProductsCount(detail[0]?.quantity_product || 0));
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createShoppingCart = async (data: any): Promise<boolean> => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ShoppingCartAPI.createShoppingCart(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                const typeAlert = response.data.message == "Producto no encontrado, se realizará la busqueda de productos parecidos al código ingresado"
                    ? "warning"
                    : "error"
                CustomSnackbar(typeAlert, response.data.message || "");
                return false;
            }
            const cart: any = [response.data.detail]
            dispatch(onFetchShoppingCart(cart || []))
            dispatch(changeStatus(ApiStatus.FETCHED))
            // CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            dispatch(changeStatus(ApiStatus.FETCHED))
            return false
        }
    }

    const editCartProduct = async (idstore: number, data: any) => {
        try {
            // dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ShoppingCartAPI.editCartProduct(idstore, data)
            if (!response?.status) {
                // dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const cart: any = [response.data.detail]
            dispatch(onFetchShoppingCart(cart || []))
            dispatch(changeStatus(ApiStatus.FETCHED))
            // CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteProductCart = async (idstore: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ShoppingCartAPI.deleteProductCart(idstore)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const cart: any = [response.data.detail]
            dispatch(onFetchShoppingCart(cart || []))
            dispatch(changeStatus(ApiStatus.FETCHED))
            // CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const changeGlobalDiscount = async (idcart: number, data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ShoppingCartAPI.changeGlobalDiscount(idcart, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedStore = (cart: Shoppingcart) => {
        try {
            dispatch(onSetSelectedShoppingcart(cart))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionStore = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    const assingCustomer = async (idcart: number, data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ShoppingCartAPI.assignCustomer(idcart, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedTypeDocument = (state: DocumentOfSale | null) => {
        try {
            dispatch(onSetSelectedTypeDocument(state))
        } catch (error) {
            console.log(error)
        }
    }

    const setSelectedSaleChannel = (state: SaleChannel | null) => {
        try {
            dispatch(onSetSelectedSaleChannel(state))
        } catch (error) {
            console.log(error)
        }
    }

    const setSelectedWayToPay = (state: WayToPay | null) => {
        try {
            dispatch(onSetSelectedWayToPay(state))
        } catch (error) {
            console.log(error)
        }
    }

    const setFolio = (state: string) => {
        try {
            dispatch(onSetFolio(state))
        } catch (error) {
            console.log(error)
        }
    }

    const clearShoppingCart = () => {
        try {
            dispatch(onFetchShoppingCart([]))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        shoppingcart,
        shoppingcartSelected,
        productsCount,
        status,
        action,
        selectedTypeDocument,
        selectedSaleChannel,
        selectedWayToPay,
        folio,
        //actions
        getShoppingCart,
        createShoppingCart,
        editCartProduct,
        deleteProductCart,
        changeGlobalDiscount,
        setSelectedStore,
        setActionStore,
        assingCustomer,
        setSelectedTypeDocument,
        setSelectedSaleChannel,
        setSelectedWayToPay,
        setFolio,
        clearShoppingCart
    }
}